import crypto from "crypto";
function getDecryptedRPC() {
  let encryptedData = process.env.NEXT_PUBLIC_ENCRYPTED_RPC;
  const algorithm = "aes-256-cbc";
  const secretKey = crypto
    .createHash("sha256") // Hash the string to make it 32 bytes
    .update("netzylo")
    .digest();

  // Use a string for the IV and ensure it's exactly 16 characters long
  const ivString = "1234567890123456"; // Must be exactly 16 characters
  const iv = Buffer.from(ivString, "utf8"); // Convert the string to a Buffer
  const decipher = crypto.createDecipheriv(algorithm, secretKey, iv);
  let decrypted = decipher.update(encryptedData, "hex", "utf8");
  decrypted += decipher.final("utf8");
  return decrypted;
}
export default getDecryptedRPC;
